export default {
    "MENU": {
        "DASHBOARD": "Fő oldal",
        "PROFILE": "Profil",
        "PLACES": "Helyszínek",
        "ARTISTS": "Előadók",
        "PROGRAMS": "Programok",
        "USERS": "Felhasználók",
        "CONTENT": "Tartalmak",
        "MEDIA": "Média",
        "POST": "Bejegyzés",
        "POSTS": "Bejegyzések",
        "CATEGORIES": "Kategóriák",
        "POST_CATEGORIES": "Tartalomkategóriák",
        "WISHLISTS": "Kívánságlisták",
        "STATISTICS": "Statisztikák",
        "SUBSCRIBERS": "Statisztikák",
        "CITIES": "Városok",
        "NEWS": "Hírek",
        "SETTINGS": "Beállítások",
        "MENUS": "Menük",
        "INFO": "Utazás/Szállás",
        "GUIDES": "Programfüzetek",
        "PAGES": "Oldalak",
        "SUPPORTERS": "Támogatók",
        "SLIDERS": "Sliderek",
        "TICKETS": "Jegyek",
        "MIDDLETILE": "Youtube Videó",
        "MEDIA": "Médiatár",
        "FORMS": "Űrlapok",
        "RECOMMENDATIONS": "Ajánló",
        "BUSES": "Buszok",
        "BUS": "Busz",
        "TRACKERS": "Trackerek",
        "ROUTES": "Útvonalak",
        "STATIONS": "Állomások",
        "TRACKERMAP": "Térkép",
        "TIMETABLE": "Menetrend",
        "NOTIFICATIONS": "Push",
        "PROGRAMCATEGORIES": "Programkategóriák",
        "GALLERY": "Galléria",
        "GALLERIES": "Gallériák",
        "SITENOTIFICATIONS": "Pop Up",
        "CONTACTPEOPLE": "Kapcsolatok",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/menu.js